import { Spinner } from '@cycle-app/ui';
import { CalendarTimeIcon, SignalIcon } from '@cycle-app/ui/icons';
import { plural } from '@cycle-app/utilities';

import { useMeetingsEvents } from 'src/hooks/integration/useMeetingsEvents';
import { openMeetingsEventsRecording } from 'src/reactives/settingsModal.reactive';

import { OngoingCta, UpcomingCta } from './HomeViewMeetingsEnabled.styles';

export const HomeViewMeetingsEnabled = () => {
  const {
    events: {
      upcoming, ongoing,
    }, isLoading,
  } = useMeetingsEvents();

  if (isLoading) return <Spinner />;

  if (ongoing.length) {
    return (
      <OngoingCta size="M" variant="secondary" onClick={openMeetingsEventsRecording}>
        <SignalIcon />
        {' '}
        {ongoing.length}
        {' '}
        {plural('ongoing meeting', ongoing.length)}
      </OngoingCta>
    );
  }

  if (upcoming.length) {
    return (
      <UpcomingCta size="M" variant="ternary" onClick={openMeetingsEventsRecording}>
        <CalendarTimeIcon />
        {' '}
        {upcoming.length}
        {' '}
        {plural('upcoming meeting', upcoming.length)}
      </UpcomingCta>
    );
  }

  return null;
};
